import { FaBuilding, FaHome, FaUser, FaUniversity, FaCircle, FaCalendarAlt, FaMoneyCheckAlt, FaTasks, FaUserPlus, FaCogs, FaSitemap, FaBullhorn, FaFolderOpen, FaUsers, FaTrophy, FaNewspaper, FaTimes, FaCalendarCheck, FaUmbrella, FaGift, FaFilePowerpoint, FaFileWord, FaEdit, FaPuzzlePiece, FaListAlt, FaHourglassHalf, FaTable, FaUserCircle, FaClock, FaCalculator, FaClipboard, FaMoneyBill, FaCalendarDay, FaFileInvoice, FaAddressBook, FaChartArea, FaBrain, FaRetweet, FaBatteryQuarter, FaBatteryFull, FaHouseUser, FaAddressCard, FaUserLock, FaInfo, FaBook, FaListUl, FaWallet } from "react-icons/fa";
import { FaBuildingShield, FaCakeCandles, FaCalendar, FaCalendarDays, FaFileCircleCheck, FaFilePen, FaGears, FaGroupArrowsRotate, FaHandshakeAngle, FaLaptopFile, FaMapLocationDot, FaMoneyBills, FaMoneyBillTransfer, FaPersonCircleQuestion, FaShield, FaShieldHalved, FaSliders, FaSnowman, FaTicket, FaUserGroup, FaListCheck, FaBookJournalWhills, FaBookBookmark, FaBookOpenReader, FaPeopleRoof,FaUserTie, FaRightFromBracket, FaChartSimple, FaBookAtlas } from "react-icons/fa6";

const GetIcon = (className) => {
    let tempComp = '';
    switch (className) {
        case 'fa-solid fa-users-gear':
            tempComp = <FaUserTie />
            break;
        case 'fa fa-university':
            tempComp = <FaUniversity />
            break;
        case 'fa-thin fa-building':
            tempComp = <FaBuilding />
            break;
        case 'fa-light fa-calendar-check':
            tempComp = <FaCalendarCheck />
            break;
        case 'fa-light fa-clipboard':
            tempComp = <FaClipboard />
            break;
        case 'fa-light fa-money-bills':
            tempComp = <FaMoneyBills />
            break;
        case 'fa-light fa-user-plus':
            tempComp = <FaUserPlus />
            break;
        case 'fa-light fa-users':
            tempComp = <FaUsers />
            break;
        case 'fa-light fa-laptop-file':
            tempComp = <FaLaptopFile />
            break;

        case 'fa-light fa-file-circle-check':
            tempComp = <FaFileCircleCheck />
            break;

        case 'fa-solid fa-calendar-day':
            tempComp = <FaCalendarDay />
            break;
        case 'fa-solid fa-money-bill-transfer':
            tempComp = <FaMoneyBillTransfer />
            break;
        case 'fa-solid fa-file-invoice':
            tempComp = <FaFileInvoice />
            break;
        case 'fa-solid fa-handshake-angle':
            tempComp = <FaHandshakeAngle />
            break;
        case 'fa-solid fa-cake-candles':
            tempComp = <FaCakeCandles />
            break;
        case 'fa-solid fa-building-shield':
            tempComp = <FaBuildingShield />
            break;
        case 'fa-solid fa-file-pen':
            tempComp = <FaFilePen />
            break;
        case 'fa-solid fa-group-arrows-rotate':
            tempComp = <FaGroupArrowsRotate />
            break;

        case 'fa fa-calendar':
            tempComp = <FaCalendarAlt />
            break;
        case 'fa fa-money':
            tempComp = <FaMoneyCheckAlt />
            break;
        case 'fa fa-tasks':
            tempComp = <FaTasks />
            break;
        case 'fa fa-user-plus':
            tempComp = <FaUserPlus />
            break;
        case 'fa fa-cog':
            tempComp = <FaCogs />
            break;
        case 'fa fa-sitemap':
            tempComp = <FaSitemap />
            break;
        case 'fa fa-bullhorn':
            tempComp = <FaBullhorn />
            break;
        case 'fa fa-folder-open':
            tempComp = <FaFolderOpen />
            break;
        case 'fa fa fa-users':
            tempComp = <FaUsers />
            break;
        case 'fa fa-trophy':
            tempComp = <FaTrophy />
            break;
        case 'fa fa-newspaper-o':
            tempComp = <FaNewspaper />
            break;
        case 'fa fa-file-text-o':
            tempComp = <FaFileWord />
            break;
        case 'fa fa-times':
            tempComp = <FaTimes />
            break;
        case 'fa fa-times':
            tempComp = <FaTimes />
            break;
        case 'fa fa-calendar-check-o':
            tempComp = <FaCalendarCheck />
            break;
        case 'fa fa-umbrella':
            tempComp = <FaUmbrella />
            break;
        case 'fa fa-gift':
            tempComp = <FaGift />
            break;
        case 'fa fa-file-powerpoint-o':
            tempComp = <FaFilePowerpoint />
            break;
        case 'fa fa-file-powerpoint-o':
            tempComp = <FaFilePowerpoint />
            break;
        case 'fa fa-pencil-square-o':
            tempComp = <FaEdit />
            break;
        case 'fa fa-puzzle-piece':
            tempComp = <FaPuzzlePiece />
            break;
        case 'fa fa-list-alt':
            tempComp = <FaListAlt />
            break;
        case 'fa fa-hourglass-half':
            tempComp = <FaHourglassHalf />
            break;
        case 'fa fa-table':
            tempComp = <FaTable />
            break;
        case 'fa fa-user-circle-o':
            tempComp = <FaUserCircle />
            break;
        case 'fa fa-ticket':
            tempComp = <FaTicket />
            break;
        case 'fa fa-clock-o':
            tempComp = <FaClock />
            break;
        case 'fa fa-calculator':
            tempComp = <FaCalculator />
            break;
        case 'fa fa-building':
            tempComp = <FaBuilding />
            break;
        case 'fa-solid fa-address-book':
            tempComp = <FaAddressBook />
            break;
        case 'fa-solid fa-map-location-dot':
            tempComp = <FaMapLocationDot />
            break;
        case 'fa-solid fa-brain':
            tempComp = <FaBrain />
            break;
        case 'fa-solid fa-snowman':
            tempComp = <FaSnowman />
            break;
        case 'fa-solid fa-retweet':
            tempComp = <FaRetweet />
            break;
        case 'fa-solid fa-battery-full':
            tempComp = <FaBatteryFull />
            break;
        case 'fa-solid fa-house-user':
            tempComp = <FaHouseUser />
            break;
        case 'fa-solid fa-calendar-days':
            tempComp = <FaCalendarDays />
            break;
        case 'fa-solid fa-address-card':
            tempComp = <FaAddressCard />
            break;
        case 'fa-solid fa-users':
            tempComp = <FaUsers />
            break;
        case 'fa-solid fa-shield-halved':
            tempComp = <FaShieldHalved />
            break;
        case 'fa-solid fa-user-lock':
            tempComp = <FaUserLock />
            break;
        case 'fa-solid fa-sliders':
            tempComp = <FaSliders />
            break;
        case 'fa-solid fa-info':
            tempComp = <FaInfo />
            break;
        case 'fa-solid fa-book':
            tempComp = <FaBook />
            break;
        case 'fa-solid fa-book-bookmark':
            tempComp = <FaBookBookmark />
            break;
        case 'fa-solid fa-book-open-reader':
            tempComp = <FaBookOpenReader />
            break;
        case 'fa-solid fa-people-roof':
            tempComp = <FaPeopleRoof />
            break;
        case 'fa-solid fa-right-from-bracket':
            tempComp = <FaRightFromBracket />
            break;
        case 'fa-solid fa-list-ul':
            tempComp = <FaListUl />
            break;
        case 'fa-solid fa-chart-simple':
            tempComp = <FaChartSimple />
            break;
        case 'fa-solid fa-book-atlas':
            tempComp = <FaBookAtlas />
            break;
        case 'fa-solid fa-wallet':
            tempComp = <FaWallet />
            break;
        case 'fa-solid fa-table':
            tempComp = <FaTable />
            break;


        default:
            tempComp = <FaListCheck />
            break;

    }
    return tempComp;
}
export default GetIcon;